/**
 * AppearanceSection — Color mode toggle (light/dark/system)
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useColorMode, ColorModePreference } from '../../contexts/ColorModeContext';
import { SectionCard, OptionSelector } from '../ui';

export const AppearanceSection = React.memo(function AppearanceSection() {
  const { t } = useTranslation();
  const { colorModePreference, setColorModePreference } = useColorMode();

  const themeModeLabels: Record<ColorModePreference, string> = {
    light: t('profile.appearance.light'),
    dark: t('profile.appearance.dark'),
    system: t('profile.appearance.system'),
  };

  return (
    <SectionCard title={t('profile.appearance.title')}>
      <OptionSelector
        label={t('profile.appearance.themeLabel')}
        options={(['light', 'dark', 'system'] as const).map((mode) => ({
          value: mode as ColorModePreference,
          label: themeModeLabels[mode as ColorModePreference],
        }))}
        value={colorModePreference}
        onChange={setColorModePreference}
        testID="profile-theme"
      />
    </SectionCard>
  );
});
